__turbopack_context__.v({
  "borderTitle": "Title-module__cR3G_a__borderTitle",
  "container": "Title-module__cR3G_a__container",
  "fadeInItems": "Title-module__cR3G_a__fadeInItems",
  "lightSubtitle": "Title-module__cR3G_a__lightSubtitle",
  "lightUi": "Title-module__cR3G_a__lightUi",
  "spacing--lg": "Title-module__cR3G_a__spacing--lg",
  "spacing--md": "Title-module__cR3G_a__spacing--md",
  "spacing--sm": "Title-module__cR3G_a__spacing--sm",
  "spacing--xl": "Title-module__cR3G_a__spacing--xl",
  "spacing--xs": "Title-module__cR3G_a__spacing--xs",
  "spacing--xxl": "Title-module__cR3G_a__spacing--xxl",
  "spacing--xxs": "Title-module__cR3G_a__spacing--xxs",
  "spacing--xxxl": "Title-module__cR3G_a__spacing--xxxl",
  "spacing--xxxs": "Title-module__cR3G_a__spacing--xxxs",
  "subtitle": "Title-module__cR3G_a__subtitle",
  "subtitleLong": "Title-module__cR3G_a__subtitleLong",
  "swapColour": "Title-module__cR3G_a__swapColour",
});
